import 'sections/services-marketplace/experts/polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {AppProvider} from '@shopify/polaris';
import I18nProvider from 'utilities/i18n/i18n-provider';
import railsData from 'utilities/rails-data';
import {AdapterLink} from 'sections/services-marketplace/experts/components/adapter-link';
import Experts from 'sections/services-marketplace/experts';

const node = document.getElementById('js-experts-mount');

function renderApp() {
  ReactDOM.render(
    <BrowserRouter>
      <AppProvider linkComponent={AdapterLink}>
        <I18nProvider>
          <Experts />
        </I18nProvider>
      </AppProvider>
    </BrowserRouter>,
    node
  );
}

if (node) {
  if (railsData('env') === 'development') {
    setTimeout(() => {
      document.body.style.display = '';
      renderApp();
    }, 0);
  } else {
    renderApp();
  }
}
